export default __webpack_public_path__ + "static/gallery18-bd56e32566dd2984f1e6c4475e0dc1bf.png";